module.exports = __webpack_public_path__ + "img/Pdf.395028da.png";